import {
  TRANSFER_GROUPS_ERROR,
  TRANSFER_GROUPS_START,
  TRANSFER_GROUPS_SUCCESS,
} from 'constants/action-types/groups/transferGroups';

export default (state, { type, payload }) => {
  switch (type) {
    case TRANSFER_GROUPS_START:
      return {
        ...state,
        transferGroups: {
          ...state.transferGroups,
          loading: true,
          error: null,
          message: null,
        },
      };
    case TRANSFER_GROUPS_SUCCESS:
      return {
        ...state,
        transferGroups: {
          ...state.transferGroups,
          loading: false,
          message: payload,
        },
      };
    case TRANSFER_GROUPS_ERROR:
      return {
        ...state,
        transferGroups: {
          ...state.transferGroups,
          loading: false,
          error: payload,
        },
      };
    default:
      return null;
  }
};
